import { Container, Shimmer, Spacer, Typography } from '@/src/ct-design/lib'
import TravellerChipsLoader from './travellerChipsLoader'

const ItineraryLoader = () => {
    return (
        <Container className='flex flex-column'>
            <Typography variant='HM2'>Personal Details</Typography>
            <Spacer className='mb-5' />
            <TravellerChipsLoader />
            <Spacer className='mb-5' />
            <Container className='flex flex-row flex-between'>
                <Container className='flex flex-column flex-1'>
                    <Typography variant='B2'>First / Given Name</Typography>
                    <Spacer className='mb-2' />
                    <Shimmer width='100%' height='40px' borderRadius='6px' />
                </Container>

                <Spacer className='mr-8' />

                <Container className='flex flex-column flex-1'>
                    <Typography variant='B2'>Last Name</Typography>
                    <Spacer className='mb-2' />
                    <Shimmer width='100%' height='40px' borderRadius='6px' />
                </Container>
            </Container>
            <Spacer className='mb-5' />
            <Container className='flex flex-row flex-between'>
                <Container className='flex flex-column flex-1'>
                    <Typography variant='B2'>Email</Typography>
                    <Spacer className='mb-2' />
                    <Shimmer width='100%' height='40px' borderRadius='6px' />
                </Container>

                <Spacer className='mr-8' />

                <Container className='flex flex-column flex-1'>
                    <Typography variant='B2'>Phone Number</Typography>
                    <Spacer className='mb-2' />
                    <Shimmer width='100%' height='40px' borderRadius='6px' />
                </Container>
            </Container>
            <Spacer className='mb-5' />
            <Container className='flex flex-row flex-between'>
                <Container className='flex flex-column flex-1'>
                    <Typography variant='B2'>Date of Birth</Typography>
                    <Spacer className='mb-2' />
                    <Shimmer width='100%' height='40px' borderRadius='6px' />
                </Container>

                <Spacer className='mr-8' />

                <Container className='flex flex-column flex-1'>
                    <Typography variant='B2'>Gender</Typography>
                    <Spacer className='mb-2' />
                    <Shimmer width='100%' height='40px' borderRadius='6px' />
                </Container>
            </Container>
            <Spacer className='mb-5' />
            <Container className='flex flex-row flex-between'>
                <Container className='flex flex-column flex-1'>
                    <Typography variant='B2'>Passport Number</Typography>
                    <Spacer className='mb-2' />
                    <Shimmer width='100%' height='40px' borderRadius='6px' />
                </Container>

                <Spacer className='mr-8' />

                <Container className='flex flex-column flex-1'>
                    <Typography variant='B2'>Passport Expiry Date</Typography>
                    <Spacer className='mb-2' />
                    <Shimmer width='100%' height='40px' borderRadius='6px' />
                </Container>
            </Container>
            <Container
                className='flex flex-row p-3 br-6 flex-between mt-8'
                style={{
                    backgroundColor: 'rgb(239 246 255)'
                }}
            >
                <Container className='flex flex-column py-1'>
                    <Shimmer width='216px' height='20px' borderRadius='6px' />
                    <Spacer className='mb-2' />
                    <Shimmer width='200px' height='28px' borderRadius='6px' />
                </Container>
            </Container>
        </Container>
    )
}

export default ItineraryLoader
